import React from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import Language from "../language/language";
import { Button } from "antd";
import ReactGA from "react-ga";

import "./stylesheets/registrationNotice.scss";
import { $const, $util } from "../../helper";

@inject("gameStore", "authStore", "navStore", "languageStore", "commonStore", "teamStore")
@withRouter
@observer
export default class RegistrationNotice extends React.Component {
  constructor() {
    super();
    this.state = {
      radioCheck: false
    };
  }

  componentDidMount() {
    const selectedGame = this.props.gameStore.selectedGame;
    if (selectedGame && selectedGame.attributes && selectedGame.attributes.title) {
      // 统计弹框曝光次数
      ReactGA.event({
        category: "registrationPopup",
        action: "exp",
        label: `${selectedGame.attributes.title}-立即报名`
      });
      this.props.commonStore.gTag("event", "registrationPopup", {
        pageName: "registrationCenter",
        competitionName: selectedGame.attributes.title,
        popupName: `${selectedGame.attributes.title}-参赛条款`
      });
    }
  }

  checkRadio = () => {
    this.setState({
      radioCheck: true
    });
  };
  summerGaSend = selectedGame => {
    if (localStorage) {
      if (!localStorage.getItem("isSummer")) {
        return;
      }
      let uuid;
      let from;
      from = localStorage.getItem("djiFrom");
      uuid = localStorage.getItem(
        `uuid_high_school_summer_join_person_game_success_${selectedGame.id}`
      );
      if (!from) {
        from = "default";
      }
      // 如果发送过就不发送了
      if (!uuid) {
        uuid = Math.random()
          .toString()
          .substr(2);
        localStorage &&
          localStorage.setItem(
            `uuid_high_school_summer_join_person_game_success_${selectedGame.id}`,
            uuid
          );
        ReactGA.event({
          category: "registration-system-join-person-game",
          action: selectedGame.title,
          label: from
        });
        this.props.commonStore.gTag("event", "registrationSystemJoinPersonGame", {
          pageName: "registrationCenter",
          competitionName: selectedGame.title,
          eventLabel: from
        });
      }
    }
  };

  agreeTerms = () => {
    const selectedGame = this.props.gameStore.selectedGame;
    if (selectedGame.joinType === "JOIN_A_DELIVERY") {
      ReactGA.event({
        category: "Recruit_Explanation",
        action: "Click",
        label: "招聘说明"
      });
      this.props.commonStore.gTag("event", "recruitExplanation", {
        pageName: "registrationCenter",
        competitionName: selectedGame.attributes.title,
        popupName: "招聘说明",
        buttonName: "下一步"
      });
    }
    this.props.gameStore.closeGameTerm();

    if (
      selectedGame &&
      selectedGame.attributes &&
      selectedGame.attributes.category &&
      selectedGame.attributes.category.registration_source_type === $const.EVENT_TYPE.TEAM
    ) {
      // 是否是“机甲大师高校联盟赛”或”机甲大师超级对抗赛“
      const isSpecialGame = this.props.gameStore.showTeamSloganGameCategoryId.includes(
        `${selectedGame.attributes.category_id}`
      );
      // 论坛战队是否有管理权限
      const bbsHasTeamManagement = this.props.authStore.bbsHasTeamManagement;
      // 论坛已有的队伍且有管理权限的（队长or领队老师）
      const bbsTeamWithManagement = this.props.authStore.bbsTeamWithManagement;
      if (isSpecialGame && bbsHasTeamManagement && bbsTeamWithManagement.length > 1) {
        // 存在多个战队，需要提示用户选择报名的战队
        this.props.teamStore.setSelectBBSTeamModalState(true);
      } else if (isSpecialGame && bbsHasTeamManagement && bbsTeamWithManagement.length === 1) {
        this.props.teamStore.setCurrentSelectBBSTeamId(bbsTeamWithManagement[0].id);
        // 仅存在一个战队，直接跳转创建战队
        this.props.history.push("/create-team");
      } else {
        this.props.authStore.showJoinOrCreateModal();
      }
    }

    if (
      selectedGame &&
      selectedGame.attributes &&
      selectedGame.attributes.category &&
      selectedGame.attributes.category.registration_source_type === $const.EVENT_TYPE.PERSON
    ) {
      // 直接报名
      const flow = $util.getPersonFlowV2(selectedGame);
      this.props.gameStore
        .registration({
          variables: {
            input: {
              attributes: {
                eventId: selectedGame.id,
                sourceType: $const.SOURCE_TYPE.PERSON,
                sourceId: this.props.authStore.user.id.toString(),
                // 默认第一个流程
                flowId: flow.id
              }
            }
          }
        })
        .then(() => {
          // 个人赛报名成功
          this.summerGaSend(selectedGame);
          if (this.props.gameStore.gameRegistrationId) {
            this.props.navStore.changeNavigation("/control-center");
            this.props.history.push(
              `/personGame-apply-info/${this.props.gameStore.gameRegistrationId}`
            );
          }
        });
    }
  };

  render() {
    return (
      <div className="registration-notice">
        <div
          className="notice-content"
          dangerouslySetInnerHTML={{
            __html: this.props.gameStore.gameLicense
          }}
        />
        <div className="confirm">
          <div>
            <input type="radio" onChange={this.checkRadio} checked={this.state.radioCheck} />
            {this.props.languageStore.lang === "zh" ? (
              <p className="confirm-text">
                <span className="next">我已阅读并同意以上条款及</span>
                <a
                  rel="noopener noreferrer"
                  href="https://www.robomaster.com/zh-CN/privacy"
                  target="_blank"
                >
                  《RoboMaster 隐私政策》
                </a>
              </p>
            ) : (
              <p className="confirm-text">
                <span className="next">
                  I have read and agree to the above terms and conditions and the{" "}
                </span>
                <a
                  rel="noopener noreferrer"
                  href="https://www.robomaster.com/en-US/privacy"
                  target="_blank"
                >
                  RoboMaster Privacy Policy
                </a>
                .
              </p>
            )}
          </div>
          <Button className="button" disabled={!this.state.radioCheck} onClick={this.agreeTerms}>
            <Language resource="NEXT" />
          </Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/registrationCenter/registrationNotice.js